export default __webpack_public_path__ + "static/media/groupsSquare.cf9fd167.svg";